import React, { useState, useEffect, useRef } from "react";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}

.jbtc {
  min-height: 100vh;
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow-x: hidden;
}

/* dot-grid */
.jbtc-dust {
  position: fixed; inset: 0; pointer-events: none; z-index: 0;
  background-image: radial-gradient(circle, rgba(201,150,42,0.09) 1px, transparent 1px);
  background-size: 36px 36px;
}

/* ── layout ── */
.jbtc-layout {
  position: relative; z-index: 1;
  max-width: 1140px; margin: 0 auto;
  padding: clamp(32px,5vw,64px) clamp(14px,4vw,32px);
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: clamp(24px, 3vw, 48px);
  align-items: start;
}

/* ══ HERO HEADER ══ */
.jbtc-hero {
  grid-column: 1 / -1;
  text-align: center;
  margin-bottom: clamp(20px, 3vw, 32px);
}
.jbtc-om {
  display: block; font-size: clamp(36px, 6vw, 52px);
  color: #C9962A; font-family: serif; line-height: 1;
  margin-bottom: 12px;
  filter: drop-shadow(0 0 12px rgba(201,150,42,0.35));
}
.jbtc-eyebrow {
  display: inline-flex; align-items: center; gap: 10px;
  font-size: clamp(9.5px, 1vw, 11px); font-weight: 600;
  letter-spacing: 2.4px; text-transform: uppercase; color: #C9962A;
  margin-bottom: 12px;
}
.jbtc-eline { width: 26px; height: 1px; background: linear-gradient(90deg,transparent,#C9962A); }
.jbtc-eline.r { background: linear-gradient(90deg,#C9962A,transparent); }
.jbtc-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(28px, 5vw, 48px); font-weight: 700;
  color: #FDF6EC; line-height: 1.18; margin-bottom: 14px;
}
.jbtc-title em { font-style: italic; color: #E8C46A; }
.jbtc-intro {
  font-size: clamp(13px, 1.4vw, 15px);
  color: rgba(253,246,236,0.72); line-height: 1.75;
  max-width: 620px; margin: 0 auto;
}
.jbtc-intro strong { color: #E8C46A; font-weight: 600; }

/* lotus divider */
.jbtc-ldiv {
  grid-column: 1 / -1;
  display: flex; align-items: center; justify-content: center; gap: 14px;
  margin-bottom: clamp(16px, 2.5vw, 24px);
}
.jbtc-lline { width: clamp(48px,8vw,110px); height: 1px; background: linear-gradient(90deg,transparent,#C9962A); }
.jbtc-lline.r { background: linear-gradient(90deg,#C9962A,transparent); }

/* ══ SIDEBAR ══ */
.jbtc-sidebar {
  position: sticky; top: 88px;
  background: rgba(201,150,42,0.07);
  border: 1px solid rgba(201,150,42,0.22);
  border-radius: 14px;
  padding: clamp(18px,2.5vw,26px) clamp(16px,2vw,22px);
}
.jbtc-nav-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(13px, 1.4vw, 15px); font-weight: 700;
  color: #E8C46A; margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(201,150,42,0.25);
}
.jbtc-nav-list { list-style: none; display: flex; flex-direction: column; gap: 6px; }
.jbtc-nav-item a {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px; border-radius: 8px;
  font-size: clamp(11px, 1.1vw, 12.5px); font-weight: 500;
  color: rgba(253,246,236,0.68); text-decoration: none;
  transition: background 0.18s, color 0.18s;
}
.jbtc-nav-item a:hover,
.jbtc-nav-item a.active {
  background: rgba(201,150,42,0.14);
  color: #E8C46A;
}
.jbtc-nav-dot {
  width: 5px; height: 5px; border-radius: 50%;
  background: #C9962A; flex-shrink: 0; opacity: 0.6;
}
.jbtc-nav-item a.active .jbtc-nav-dot { opacity: 1; }

/* ══ MAIN CONTENT ══ */
.jbtc-main { min-width: 0; }

.jbtc-sections { display: flex; flex-direction: column; gap: clamp(12px,1.8vw,16px); }

.jbtc-card {
  background: rgba(201,150,42,0.06);
  border: 1px solid rgba(201,150,42,0.18);
  border-radius: 14px;
  padding: clamp(18px,2.5vw,26px) clamp(18px,2.5vw,26px);
  scroll-margin-top: 100px;
  transition: border-color 0.2s, background 0.2s;
}
.jbtc-card:hover { border-color: rgba(201,150,42,0.4); background: rgba(201,150,42,0.09); }

.jbtc-card-head {
  display: flex; align-items: center; gap: 12px;
  margin-bottom: clamp(10px,1.6vw,14px);
}
.jbtc-badge {
  width: clamp(30px,3.5vw,38px); height: clamp(30px,3.5vw,38px);
  border-radius: 50%;
  background: rgba(201,150,42,0.15); border: 1.5px solid rgba(201,150,42,0.4);
  display: flex; align-items: center; justify-content: center;
  font-family: 'Playfair Display', serif;
  font-size: clamp(12px,1.3vw,15px); font-weight: 700; color: #C9962A;
  flex-shrink: 0;
}
.jbtc-card-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px,1.6vw,18px); font-weight: 700; color: #FDF6EC;
}
.jbtc-card-body {
  font-size: clamp(12px,1.2vw,13.5px);
  color: rgba(253,246,236,0.7); line-height: 1.75;
  padding-left: clamp(40px,4.5vw,50px);
}
.jbtc-card-list {
  list-style: none; display: flex; flex-direction: column; gap: 8px;
  padding-left: clamp(40px,4.5vw,50px);
}
.jbtc-card-list li {
  position: relative;
  font-size: clamp(12px,1.2vw,13.5px);
  color: rgba(253,246,236,0.7); line-height: 1.7;
  padding-left: 14px;
}
.jbtc-card-list li::before {
  content: ''; position: absolute; left: 0; top: 9px;
  width: 5px; height: 5px; border-radius: 50%;
  background: #C9962A; opacity: 0.65;
}

/* contact card specifics */
.jbtc-contact-row {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px; border-radius: 8px;
  background: rgba(201,150,42,0.08); border: 1px solid rgba(201,150,42,0.18);
  margin-top: 10px;
}
.jbtc-contact-icon { font-size: 16px; flex-shrink: 0; }
.jbtc-contact-val {
  font-size: clamp(12px,1.2vw,13.5px); color: rgba(253,246,236,0.82);
  font-weight: 500;
}
.jbtc-contact-val a { color: #C9962A; text-decoration: underline; word-break: break-all; }

/* ── footer ── */
.jbtc-footer {
  grid-column: 1 / -1;
  text-align: center;
  margin-top: clamp(24px,4vw,40px);
  padding-top: clamp(16px,2.5vw,24px);
  border-top: 1px solid rgba(201,150,42,0.2);
}
.jbtc-footer-sym { font-size: 18px; color: #C9962A; opacity: 0.5; margin-bottom: 8px; }
.jbtc-footer p { font-size: clamp(11.5px,1.1vw,13px); color: rgba(253,246,236,0.48); line-height: 1.65; }
.jbtc-footer strong { color: rgba(253,246,236,0.7); }

/* ══ RESPONSIVE ══ */

/* hide sidebar below lg */
@media (max-width: 900px) {
  .jbtc-layout { grid-template-columns: 1fr; }
  .jbtc-sidebar { display: none; }
  .jbtc-ldiv, .jbtc-hero { grid-column: 1; }
  .jbtc-footer { grid-column: 1; }
}

/* mobile body/list indent */
@media (max-width: 480px) {
  .jbtc-card-body, .jbtc-card-list { padding-left: 16px; }
}
@media (max-width: 360px) {
  .jbtc-layout { padding: 24px 12px; }
}
`;

/* ─── Data ───────────────────────────────────────────────────────────────── */
const SECTIONS = [
  {
    id: "eligibility",
    num: 1,
    title: "Eligibility",
    body: "You must be 18 years or older to register on Jain Var Vadhu. By creating an account, you confirm that you are legally single, divorced, or widowed and eligible for marriage under the laws applicable to you.",
  },
  {
    id: "registration",
    num: 2,
    title: "Account Registration",
    body: "You agree to provide accurate, true, and complete information while creating your profile on Jain Var Vadhu. You are responsible for maintaining the confidentiality of your login details. Any false information or impersonation may lead to suspension or termination of your account.",
  },
  {
    id: "obligations",
    num: 3,
    title: "Member Obligations",
    body: "You must use Jain Var Vadhu only for lawful matrimonial purposes rooted in Jain values. Sharing obscene, abusive, or offensive content is strictly prohibited. You agree not to use this platform for commercial, promotional, or fraudulent purposes.",
  },
  {
    id: "privacy",
    num: 4,
    title: "Privacy Policy",
    body: "Your personal information will be collected and processed as per our Privacy Policy. Jain Var Vadhu takes reasonable security measures to protect your data but is not liable for any leaks caused by third parties.",
  },
  {
    id: "interaction",
    num: 5,
    title: "Interaction & Communication",
    body: "Members are responsible for verifying the details of other members before proceeding with any discussions or alliances. Jain Var Vadhu does not guarantee the accuracy of profiles or the success of any matches, and is not responsible for offline meetings, transactions, or disputes.",
  },
  {
    id: "payment",
    num: 6,
    title: "Payment & Subscription",
    body: "Paid plans on Jain Var Vadhu are non-refundable unless explicitly stated otherwise. Subscription benefits and validity will be as per the plan details at the time of purchase.",
  },
  {
    id: "termination",
    num: 7,
    title: "Termination",
    body: "Jain Var Vadhu reserves the right to suspend or terminate your account if you violate any terms or engage in fraudulent or illegal activities. You may delete your account at any time by contacting our support team.",
  },
  {
    id: "liability",
    num: 8,
    title: "Limitation of Liability",
    list: [
      "Any incorrect or false information provided by members.",
      "Any disputes, frauds, or financial losses arising from interactions between members.",
      "Any interruption or failure of the Jain Var Vadhu platform due to technical issues.",
    ],
  },
  {
    id: "changes",
    num: 9,
    title: "Changes to Terms",
    body: "Jain Var Vadhu may update these Terms and Conditions at any time. Users will be notified of major changes via email or platform notifications.",
  },
  {
    id: "contact",
    num: 10,
    title: "Contact Us",
    isContact: true,
    body: "For any questions or concerns about these Terms, you can reach us at:",
    contact: [
      {
        icon: "📧",
        label: "jainVar Vadhu@gmail.com",
        href: "mailto:jainVar Vadhu@gmail.com",
      },
      { icon: "📞", label: "+91 98265 79080", href: "tel:+919826579080" },
    ],
  },
];

const NAV = SECTIONS.map((s) => ({ id: s.id, label: `${s.num}. ${s.title}` }));

/* ─── Lotus SVG ──────────────────────────────────────────────────────────── */
const Lotus = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
  >
    <ellipse cx="14" cy="16" rx="4" ry="9" fill="#C9962A" opacity=".9" />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(-30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(-58 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(58 14 16)"
    />
    <ellipse cx="14" cy="24" rx="7" ry="2.5" fill="#C9962A" opacity=".25" />
  </svg>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const TermsAndConditions = () => {
  const [activeId, setActiveId] = useState("eligibility");
  const cardRefs = useRef({});

  /* inject CSS */
  useEffect(() => {
    const id = "jbtc-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  /* highlight sidebar on scroll */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: "-20% 0px -70% 0px" },
    );
    Object.values(cardRefs.current).forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="jbtc">
      <div className="jbtc-dust" aria-hidden="true" />

      <div className="jbtc-layout">
        {/* ── HERO ── */}
        <header className="jbtc-hero">
          <span className="jbtc-om" aria-label="Om">
            ꣽ
          </span>
          <div className="jbtc-eyebrow" aria-hidden="true">
            <span className="jbtc-eline" />
            Jain Var Vadhu · Legal
            <span className="jbtc-eline r" />
          </div>
          <h1 className="jbtc-title">
            Terms &amp; <em>Conditions</em>
          </h1>
          <p className="jbtc-intro">
            Welcome to <strong>Jain Var Vadhu</strong> — a sacred matrimonial
            platform guided by Ahimsa, Satya, and Dharma. By using our services,
            you agree to the following Terms &amp; Conditions.
          </p>
        </header>

        {/* lotus divider */}
        <div className="jbtc-ldiv" aria-hidden="true">
          <div className="jbtc-lline" />
          <Lotus />
          <div className="jbtc-lline r" />
        </div>

        {/* ── SIDEBAR ── */}
        <aside className="jbtc-sidebar" aria-label="Quick navigation">
          <div className="jbtc-nav-title">☸ Quick Navigation</div>
          <ul className="jbtc-nav-list">
            {NAV.map(({ id, label }) => (
              <li key={id} className="jbtc-nav-item">
                <a
                  href={`#${id}`}
                  className={activeId === id ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    cardRefs.current[id]?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  <span className="jbtc-nav-dot" aria-hidden="true" />
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* ── MAIN ── */}
        <main className="jbtc-main" aria-label="Terms and Conditions">
          <div className="jbtc-sections">
            {SECTIONS.map((sec) => (
              <article
                key={sec.id}
                id={sec.id}
                className="jbtc-card"
                ref={(el) => (cardRefs.current[sec.id] = el)}
              >
                <div className="jbtc-card-head">
                  <div className="jbtc-badge" aria-hidden="true">
                    {sec.num}
                  </div>
                  <h2 className="jbtc-card-title">{sec.title}</h2>
                </div>

                {sec.body && <p className="jbtc-card-body">{sec.body}</p>}

                {sec.list && (
                  <ul className="jbtc-card-list" aria-label={sec.title}>
                    {sec.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}

                {sec.contact && (
                  <div style={{ paddingLeft: "clamp(40px,4.5vw,50px)" }}>
                    {sec.contact.map(({ icon, label, href }) => (
                      <div key={label} className="jbtc-contact-row">
                        <span className="jbtc-contact-icon" aria-hidden="true">
                          {icon}
                        </span>
                        <span className="jbtc-contact-val">
                          <a href={href}>{label}</a>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </article>
            ))}
          </div>
        </main>

        {/* ── FOOTER ── */}
        <footer className="jbtc-footer">
          <div className="jbtc-footer-sym" aria-hidden="true">
            ☸
          </div>
          <p>
            <strong>Divine Values. Sacred Bond. Eternal Together.</strong>
          </p>
          <p style={{ marginTop: 6 }}>
            © {new Date().getFullYear()} Jain Var Vadhu. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default TermsAndConditions;
